import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { DefinitionOrderTemperatureControl } from '@shared/enums/definition-order-temperature-control.enum';
import { OrderTypeShortcuts } from '@shared/enums/order-types-shortcuts.enum';
import { Order } from '@features/orders/models/order.model';
import { ColorPalette } from '@shared/enums/color-palette.enum';
import { Pallet } from '@features/orders/models/pallet.model';
import { IconType } from '@shared/enums/icon-type.enum';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { OrderLineStatus } from '@shared-features/enums/order-line-status.enum';

@Component({
  selector: 'app-orders-list-item',
  templateUrl: './orders-list-item.component.html',
  styleUrls: ['./orders-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdersListItemComponent implements OnChanges {
  @Input() orderType: 'detailed' | 'undetailed' = 'detailed';
  @Input() order: Order;
  @Input() timeline: boolean;
  @Input() readonly: boolean;
  @Input() detailed = true;
  @Input() showOrderType: boolean;
  @Input() index: number;
  @Input() lastIndex: number;
  @Input() actionIcon = 'add-square';
  @Input() totalCount: number;
  @Input() totalItemsCount: number;

  //////////////////////////////////////////////////////////
  // For undetailed order
  // @Input() selected: boolean;
  @Input() selectedPalletsCount: number;
  @Output() selectQuantity = new EventEmitter<number>();
  selectedQuantity: number;
  availableQuantity: number;
  //////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////
  // For detailed order
  @Input() pallets: Pallet[];
  @Output() expandPallets = new EventEmitter();
  @Output() removePallet = new EventEmitter<{ order: Order; pallet: Pallet; index: number }>();
  selectedPalletForPopover: Pallet;
  palletsExpanded = false;
  //////////////////////////////////////////////////////////

  popoverPosition: ConnectedPosition = {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
  };

  protected isDelivered: boolean;
  protected readonly DefinitionOrderTemperatureControl = DefinitionOrderTemperatureControl;
  protected readonly OrderTypeShortcuts = OrderTypeShortcuts;
  protected readonly ColorPalette = ColorPalette;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.calculateQuantities();
  }

  selectOrder() {
    this.selectQuantity.emit(this.selectedQuantity);
  }
  modifyQuantity(update: number) {
    this.selectedQuantity += update;
    this.changeDetectorRef.markForCheck();
  }

  private calculateQuantities() {
    this.selectedQuantity = this.totalCount - (this.selectedPalletsCount || 0);
    this.availableQuantity = this.selectedQuantity;
    this.isDelivered = this.order.orderLineStatus === OrderLineStatus.Delivered;
  }

  protected readonly IconType = IconType;

  handleExpandPallets() {
    this.palletsExpanded = !this.palletsExpanded;
    // if (this.palletsExpanded) {
    //   this.expandPallets.emit();
    // }
  }
}
